import type { QueryClient } from '@tanstack/react-query';
import { applyStatusActionToCalendarCell } from '../adapters/calendarAdapters';
import type { CalendarDayResponse } from '../api/types';

/** Puts a status change on the appointment's card in every cached day of the location. */
export function patchCalendarDayCell(
  queryClient: QueryClient,
  locationId: number,
  appointmentId: number,
  action: string,
): void {
  queryClient.setQueriesData<CalendarDayResponse>(
    { queryKey: ['calendar', 'day', locationId] },
    (prev) => {
      if (!prev?.cells.some((c) => c.appointment_id === appointmentId)) return prev;
      return {
        ...prev,
        cells: prev.cells.map((c) =>
          c.appointment_id === appointmentId ? applyStatusActionToCalendarCell(c, action) : c,
        ),
      };
    },
  );
}
